export default function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
}



//////////////////
// WEBPACK FOOTER
// ./~/promise-polyfill/src/finally.js
// module id = 208
// module chunks = 6